import PropTypes from "prop-types"
import { forwardRef } from "react"
import styled from "styled-components"

import Button from "components/ui/button"
import { cn } from "styles/utils"

export const SizeBox = ({
  availableHoliday = false,
  className = "",
  ...props
}) => (
  <Button
    className={cn("size-box", className)}
    data-available-holiday={availableHoliday}
    {...props}
  />
)

SizeBox.propTypes = {
  availableHoliday: PropTypes.bool,
  className: PropTypes.string,
}

export const WidthSizeBox = styled.div`
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  align-items: center;
  background-color: ${(props) => (props.selected ? "white" : "none")};
  border: ${(props) => (props.selected ? "2px solid" : "none")};
  border-color: ${(props) => (props.selected ? "#1ABBDA" : "#646464")};
  border-radius: 6px;
  box-shadow: ${(props) => (props.selected ? "0 0 2px #1ABBDA" : "none")};
  color: #646464;
  display: flex;
  flex-direction: column;
  font-size: 20px;
  font-weight: 500;
  height: 75px;
  justify-content: flex-end;
  line-height: 13px;
  min-height: 75px;
  min-width: 75px;
  padding-top: 2px;
  transition: all 100ms ease-in;
  user-select: none;

  &:hover,
  &:active {
    outline: none;
  }
`

export const SizeBoxSmall = ({ selected = false, ...props }) => (
  <div
    className={cn(
      "text-neutral text-12 mr-15 ml-4 flex items-center justify-center rounded-full border bg-white font-medium leading-9 transition-all duration-300 ease-in",
      selected
        ? "ring-3 ring-selected border-selected"
        : "border-grey-65 shadow-none"
    )}
    style={{
      height: "40px",
      maxHeight: "40px",
      maxWidth: "40px",
      minHeight: "40px",
      minWidth: "40px",
    }}
    {...props}
  />
)

SizeBoxSmall.propTypes = {
  selected: PropTypes.bool,
}

export const Size = (props) => <div className="flex flex-nowrap" {...props} />

export const SizeContainer = forwardRef((props, ref) => (
  // CHECK KONAM
  <div className="px-15 basis-auto py-8 text-center" ref={ref} {...props} />
))

SizeContainer.displayName = "SizeContainer"

export const WidthSizeContainer = styled.div`
  flex-basis: auto;
  padding: 8px 15px 8px 1px;
  text-align: center;
`
